import PropTypes from "prop-types";

/**
 * PropTypes for IconButton component
 *
 * @property {ReactNode} [icon] - Icon element to display
 * @property {string} [label] - Accessibility label
 * @property {string} [appearance] - Visual appearance variant
 * @property {string} [tooltip] - Tooltip text on hover
 * @property {string} [tooltipPosition] - Tooltip position
 * @property {string} [shape] - Button shape variant
 * @property {boolean} [isDisabled] - Disabled state
 * @property {function} [onClick] - Click handler callback
 * @property {string} [className] - Additional CSS classes
 * @property {string} [size] - Button size variant
 */
export const iconButtonPropTypes = {
  icon: PropTypes.node,
  label: PropTypes.string,
  appearance: PropTypes.oneOf(["", "primary", "secondary", "success", "danger", "warning"]),
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.oneOf(["top", "bottom", "left", "right", ""]),
  shape: PropTypes.oneOf(["", "circle"]),
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(["", "small", "medium", "large"]),
};
